import React from 'react';
import styled from 'astroturf/react';

import { Spinner } from '../CreateSocialItem/Spinner';

const Container = styled.div`
  @import 'stylesheets/design_system/_deprecated_grid.scss';
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 24px;
  text-align: center;
  background: var(--Blue-Secondary-1, #eef2f9);

  @include medium-up {
    border-radius: 6px;
  }
`;

const Contents = styled.div<{ truncate?: boolean }>`
  @import 'stylesheets/design_system/_util.scss';
  @import 'stylesheets/design_system/font.scss';

  @include body__medium;

  &.truncate {
    @include text-ellipsis(2, 20px);
  }
`;

const ContentsBold = styled.span`
  @import 'stylesheets/design_system/font.scss';

  @include body__medium_medium;
`;

type Props = {
  // The title of a work that we are downloading. Should be limited in length to
  // ~40 characters. Takes precedence over the topic
  downloadWorkTitle?: string;
  // A new topic that recommendations are being updated using. Can be any
  // length.
  recommendationTopic?: string;
};

export const BigCardLoadingSpinner: React.FC<Props> = ({
  downloadWorkTitle,
  recommendationTopic,
}) => {
  let contents;
  if (downloadWorkTitle) {
    contents = (
      <Contents>
        We are getting your paper{' '}
        <ContentsBold>“{downloadWorkTitle}”</ContentsBold> and refining your
        paper recommendations
      </Contents>
    );
  } else {
    contents = (
      <Contents truncate>
        We are refining your recommendations for the best research updates for
        <br />
        <ContentsBold>{recommendationTopic}</ContentsBold>
      </Contents>
    );
  }

  return (
    <Container>
      <Spinner blue size={48} />
      {contents}
    </Container>
  );
};
